import { useState, useEffect } from "react";
import { Clock, CreditCard } from "lucide-react";
import { Button } from "@ui";

interface DailyLimitOverlayProps {
  resets_at: string;
  onSubscribe: () => void;
}

function calculateTimeLeft(resets_at: string): { hours: number; minutes: number } {
  const resetDate = new Date(resets_at);
  const now = new Date();
  const diffMs = Math.max(0, resetDate.getTime() - now.getTime());
  const hours = Math.floor(diffMs / (1000 * 60 * 60));
  const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
  return { hours, minutes };
}

export function DailyLimitOverlay({ resets_at, onSubscribe }: DailyLimitOverlayProps) {
  const [timeLeft, setTimeLeft] = useState(() => calculateTimeLeft(resets_at));

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft(resets_at));
    }, 60000); // Update every minute

    return () => clearInterval(timer);
  }, [resets_at]);

  return (
    <div className="absolute inset-0 bg-slate-900/95 backdrop-blur-sm rounded-xl flex flex-col items-center justify-center z-20 p-6">
      <div className="flex flex-col items-center gap-4 text-center max-w-sm">
        <div className="w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center">
          <Clock className="w-6 h-6 text-amber-600" />
        </div>

        <div className="flex flex-col gap-2">
          <h3 className="text-lg font-semibold text-white">
            Limite quotidienne atteinte
          </h3>
          <p className="text-sm text-slate-300">
            Vous avez utilise votre quota journalier. Revenez demain ou passez a un abonnement pour continuer sans limite.
          </p>
        </div>

        <div className="flex items-center gap-2 text-amber-400 text-sm">
          <Clock className="w-4 h-4" />
          <span>
            Reset dans {timeLeft.hours > 0 && `${timeLeft.hours}h `}{timeLeft.minutes}min
          </span>
        </div>

        <Button
          onClick={onSubscribe}
          icon={CreditCard}
          variant="primary"
          className="mt-2"
        >
          Voir les abonnements
        </Button>
      </div>
    </div>
  );
}
